import React from 'react';
import { connect } from 'react-redux';
import { Analytics } from 'packages';
import uiActions from 'tradera-state/ui/actions';

const VideoButton = ({ dispatch, title, pageType, videoId, className }) => {
    const handleVideoClick = () => {
        dispatch(uiActions.openVideoModal({ videoId, title, pageType }));
        Analytics.trackEvent({
            category: 'How to page',
            action: 'Content',
            label: `View ${
                pageType === 'How To Buy' ? 'Buying' : 'Selling'
            } video`
        });
    };

    return (
        <div className={className} onClick={() => handleVideoClick()}>
            <svg
                width="83px"
                height="62px"
                viewBox="0 0 83 62"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg">
                <g
                    id="Web---Logged-out---Info-page"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd">
                    <g
                        id="Logged-in---To-Buy-Copy"
                        transform="translate(-679.000000, -278.000000)">
                        <g
                            id="Youtube"
                            transform="translate(679.000000, 278.000000)">
                            <rect
                                id="Rectangle"
                                fill="#FFFFFF"
                                x="19"
                                y="7"
                                width="51"
                                height="51"
                                rx="8"
                            />
                            <path
                                d="M71.9437083,2.26911458 L53.6352917,0.67828125 C45.5842917,-0.0237604167 37.4191667,-0.0237604167 29.3647083,0.67828125 L11.0562917,2.26911458 C4.75520833,2.81553125 0,7.99957292 0,14.3283229 L0,47.1790312 C0,53.5077812 4.75520833,58.6918229 11.0562917,59.2382396 L29.3647083,60.8290729 C33.3902083,61.1818229 37.443375,61.3547396 41.5,61.3547396 C45.556625,61.3547396 49.6097917,61.1818229 53.6352917,60.8290729 L71.9437083,59.2382396 C78.2447917,58.6883646 83,53.5043229 83,47.1790312 L83,14.3283229 C83,7.99957292 78.2447917,2.81553125 71.9437083,2.26911458 Z M31.125,15.1894479 C31.125,14.5565729 31.4708333,13.9721146 32.027625,13.6712396 C32.276625,13.5329062 32.567125,13.4602812 32.8541667,13.4602812 C33.1861667,13.4602812 33.5077917,13.5536562 33.7879167,13.7334896 L57.99625,29.2959896 C58.49425,29.6176146 58.7916667,30.1605729 58.7916667,30.7519479 C58.7916667,31.3433229 58.49425,31.8862812 57.9997083,32.2044479 L33.791375,47.7669479 C33.272625,48.1024063 32.5740417,48.1300729 32.027625,47.8291979 C31.4708333,47.5317813 31.125,46.9473229 31.125,46.3144479 L31.125,15.1894479 Z"
                                id="Shape"
                                fill="#FF0000"
                                fillRule="nonzero"
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
};

VideoButton.defaultProps = {
    className: ''
};

const mapStateToProps = (state, ownProps) => ({
    ...ownProps
});

export default connect(mapStateToProps)(VideoButton);
